module.exports = __webpack_public_path__ + "static/media/historia_aparicion_movil.9a096061.jpg";